import React, {useState} from 'react';
import { useSnackbar } from 'notistack';
import { Grid, Paper } from "@material-ui/core";
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { withRouter } from 'react-router';
import { checkApiStatus } from '../../utils_v2';
import { ExportMenu, PageLoader } from '../../shared_elements';
import { globalGetService } from '../../../globalServices';
import { checkPermission } from '../../../console_management/utils_v2';
import { trackActivity } from '../../../utils/mixpanel';

const AssetTrackerReport = ({ownerList}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [start_date, setStartDate] = useState('');
    const [end_date, setEndDate] = useState('');

    const exportAssetTrackerReport = (extension) => {
        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            start_date: start_date ? '' : 'Please enter From Date',
            end_date: end_date ? '' : 'Please enter To Date',
        }
        if(start_date == 'Invalid date'){
            validationInputs = {
                ...validationInputs,
                start_date: 'Please enter From Date'
            }
        }
        if(end_date == 'Invalid date'){
            validationInputs = {
                ...validationInputs,
                end_date: 'Please enter To Date'
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            globalGetService(`/console/export-assembly-lease-asset-report/?start_date=${moment(start_date).format(backendDateFormat)}&end_date=${moment(end_date).format(backendDateFormat)}`)
            .then(response => {
                setLoading(false);
                if(checkApiStatus(response)){
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', { page_title: 'Custom Report', item_type: 'Export', event_type:'Engine Tracker Report Exported', event_desc: 'Engine Tracker Report Exported Successfully' })
                    setError({})
                }else{
                    // enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }
            });
        }else{
            setError(validationInputs)
        }
    }
    const onResetErrorKey = (keyParam) => {
        setError({...error, [keyParam]:''})
    }
    return(
        <Paper square>
            <Grid container spacing={0} alignItems='center'>
                <Grid item md={12}>
                    <div className='custom-rpt-card'>
                        <div className='rpt-card-header'>
                            <Grid container spacing={1}>
                                <Grid item md={9}>
                                    <h4>Engine Tracker Report</h4>
                                    <p>Provides a comprehensive fleet level Engine Movement data within a specified period.</p>
                                </Grid>
                                <Grid item md={3}>
                                {checkPermission('reports','custom_reports','EXP') ? <ExportMenu 
                                        exportReportFn={(file) => exportAssetTrackerReport(file.extension)}
                                        files={[{title:'EXCEL', extension:'xlsx'}]}
                                    /> : null }
                                </Grid>
                            </Grid>
                        </div>
                        <div className='rpt-card-body'>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="start_date"
                                            label="From Date"
                                            format={fieldDateFormat}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            maxDate={moment()}
                                            value={start_date}
                                            error={error.start_date ? true : false}
                                            helperText={error.start_date ? error.start_date : ''}
                                            onChange={(data) => {setStartDate(('start_date', moment(data).format(backendDateFormat)));onResetErrorKey('start_date')}}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="end_date"
                                            label="To Date"
                                            format={fieldDateFormat}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            minDate={start_date? moment(start_date) : '01-01-1900'}
                                            maxDate={moment()}
                                            value={end_date}
                                            error={error.end_date ? true : false}
                                            helperText={error.end_date ? error.end_date : ''}
                                            onChange={(data) => {setEndDate(('end_date', moment(data).format(backendDateFormat)));onResetErrorKey('end_date')}}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </Grid>
            { isLoading ? <PageLoader/>:null}
        </Paper>
    )
}
export default withRouter(AssetTrackerReport);